var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "search-filter"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    result: "light"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255,255,255, 0.6)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "light",
    operator: "in",
    result: "light"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "dark"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2e3032"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "dark",
    operator: "in",
    result: "dark"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    result: "light"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255,255,255, 0.6)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "light",
    operator: "in",
    result: "light"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "dark0"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#494c50"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "dark0",
    operator: "in",
    result: "dark0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "dark"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "dark0"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "light"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4f475d",
    filter: "url(#search-filter)",
    d: "M23.832 19.641l-6.821-6.821c2.834-5.878-1.45-12.82-8.065-12.82-4.932 0-8.946 4.014-8.946 8.947 0 6.508 6.739 10.798 12.601 8.166l6.879 6.879c1.957.164 4.52-2.326 4.352-4.351zm-14.886-4.721c-3.293 0-5.973-2.68-5.973-5.973s2.68-5.973 5.973-5.973c3.294 0 5.974 2.68 5.974 5.973s-2.68 5.973-5.974 5.973z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c317063adfb114b26d95f0fb0ee58b8f.svg";
export { ForwardRef as ReactComponent };